import {
  getAllExpenseCategories,
  createExpenseCategory,
  createAllExpenseCategories,
  updateExpenseCategory,
  deleteExpenseCategory,
} from '@/services/expenseCategory';

const state = {
  expenseCategories: [],
  processed: false,
};

const getters = {
  getExpenseCategories(state) {
    return state.expenseCategories;
  },
  expenseCategoryProcessed(state) {
    return state.processed;
  },
};

const actions = {
  fetchExpenseCategories({ commit }, params) {
    commit('SET_PROCESSING');
    return new Promise((resolve, reject) => {
      getAllExpenseCategories(params)
        .then((response) => {
          commit('SET_EXPENSECATEGORIES', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createExpenseCategory({ commit }, expenseCategory) {
    return new Promise((resolve, reject) => {
      createExpenseCategory(expenseCategory)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createAllExpenseCategories({ commit }, expenseCategories) {
    return new Promise((resolve, reject) => {
      createAllExpenseCategories(expenseCategories)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateExpenseCategory({ commit }, expenseCategory) {
    return new Promise((resolve, reject) => {
      updateExpenseCategory(expenseCategory)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteExpenseCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteExpenseCategory(id)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  SET_EXPENSECATEGORIES(state, data) {
    state.expenseCategories = data;
    state.processed = true;
  },
  SET_PROCESSING(state) {
    state.processed = false;
  },
  SET_PROCESSED(state) {
    state.processed = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
